export default "__VITE_ASSET__DSv_lydK__"